import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';

import { useViewFeedback } from './hooks/use-view-feedback';
import { ViewFeedbackContent } from './view-feedback-content';

export const ViewFeedbackModal: FC = () => {
	const { t } = useTranslation('feedback');
	const { isOpen, onClose, error, evaluation, isLoading } = useViewFeedback();

	if (!evaluation) {
		return null;
	}

	const isFeedbackComplete = evaluation.isComplete();

	return (
		<Modal autoFocus={false} isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="2xl">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader borderBottomWidth={rem(1)} borderColor="gray.100" borderStyle="solid" color="gray.900">
					{t(isFeedbackComplete ? 'feedback.give.modal_header_view_feedback' : 'feedback.give.modal_header')}
				</ModalHeader>
				<ModalCloseButton size="lg" borderRadius="full" />

				<ModalBody p={2}>
					<ViewFeedbackContent error={error} isLoading={isLoading} evaluation={evaluation} />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
